<template>
  <div class="wallet-networks-selector" :class="{ 'wallet-networks-selector_error': !networkId }">
    <form-input-display
      v-click-outside="() => (isOpenNetworkSelector ? (isOpenNetworkSelector = false) : null)"
      :is-open="isOpenNetworkSelector"
      :is-mobile="isMobile"
      :label="getContent(fieldsSettings, defaultLocaleFieldsSettings, 'fieldsControls.networkSelect.label')"
      :value="displayedNetwork"
      :list-alignment="'right'"
      :full-width-list="true"
      :list-width="listWidth"
      @click-selector="toggleNetworkSelector"
    >
      <list-simple
        v-if="!isMobile"
        :value="localNetworkId"
        @update:value="val => (localNetworkId = val)"
        :list="networkList"
        @selected="setNetwork"
        :searchValue="''"
      />
    </form-input-display>

    <!-- Мобильный bottom sheet -->
    <layout-bottom-sheet v-if="isMobile" ref="networkSelector" @closed="isOpenNetworkSelector = false">
      <template #header>
        <span class="title">
          {{ getContent(fieldsSettings, defaultLocaleFieldsSettings, 'fieldsControls.networkSelect.label') }}
        </span>
      </template>

      <list-simple
        :value="localNetworkId"
        @update:value="val => (localNetworkId = val)"
        :list="networkList"
        @selected="setNetwork"
        :searchValue="''"
      />

      <template #footer>
        <button-base type="gray" size="sm" @click="toggleNetworkSelector('close')">
          {{ getContent(layoutData, defaultLocaleLayoutData, 'buttons.close') }}
        </button-base>
      </template>
    </layout-bottom-sheet>
  </div>
</template>

<script setup lang="ts">
  interface INetworksOptions {
    id: string | 'native';
    name: string;
  }

  interface Props {
    networkSelectOptions: INetworksOptions[];
    networkId?: string | 'native';
    listWidth?: string;
  }

  const props = defineProps<Props>();

  const emit = defineEmits<{
    'update:networkId': [code: string | undefined];
  }>();

  const networkSelector = ref();
  const isOpenNetworkSelector = ref(false);

  const localNetworkId = computed({
    get: () => props.networkId,
    set: val => emit('update:networkId', val),
  });

  const { isMobile } = storeToRefs(useDeviceStore());
  const { fieldsSettings, defaultLocaleFieldsSettings, layoutData, defaultLocaleLayoutData } =
    storeToRefs(useGlobalStore());
  const { getContent } = useProjectMethods();

  const networkList = computed(() => {
    return props.networkSelectOptions.map(item => {
      const [chain] = item.name.split(' ');
      let name = chain;

      if (item.id) {
        name += ` (${item.id})`;
      }

      return {
        id: item.id ?? 'native',
        name,
      };
    });
  });

  const displayedNetwork = computed(() => {
    return localNetworkId.value
      ? networkList.value.find(item => item.id === localNetworkId.value)?.name
      : getContent(fieldsSettings.value, defaultLocaleFieldsSettings.value, 'fieldsControls.networkSelect.placeholder');
  });
  const toggleNetworkSelector = (action?: 'open' | 'close') => {
    if (isMobile.value) {
      if (action === 'close') {
        networkSelector.value.close();
      } else {
        networkSelector.value.open();
      }
    } else {
      isOpenNetworkSelector.value = !isOpenNetworkSelector.value;
    }
  };

  const setNetwork = (id: string) => {
    toggleNetworkSelector('close');
    localNetworkId.value = id;
  };
</script>

<style src="~/assets/styles/components/wallet/networks-selector.scss" lang="scss" />
